import React, {ReactElement, useEffect, useState} from "react";
import {StyledBoxColumn, StyledBoxRow} from "../shared/StyledComponents";
import {PD_MD, PD_XLG} from "../shared/dimens";
import {Button, TextField, Typography} from "@mui/material";
import {genGuestName} from "./usernamegen";
import {PathProps} from "../index";
import {NewRoomHelper} from "./EditRoomHelper";
import Markdown from "react-markdown";
import {Action} from "../shared/types";
import {getMemberAuth} from "../shared/auth";

export function HeaderButtons(props: { actions: Action[] }) {
  return <StyledBoxRow style={{position: "absolute", zIndex: 2, top: PD_MD, right: PD_MD}}>
    {props.actions.map(action => <Button onClick={() => action.onClick()}>{action.text}</Button>)}
  </StyledBoxRow>;
}

export function BuzzButton(props: { action: Action, variant?: "outlined" | "contained" }): ReactElement {
  return <Button
    variant={props.variant || "contained"}
    style={{
      padding: PD_MD,
      fontSize: "120%",
      fontWeight: "bold"
    }}
    onClick={props.action.onClick}>{props.action.text}</Button>;
}

export function CreateOrJoinPage(props: {
  path: PathProps,
  title?: string,
  text?: string,
  joinRoomId?: string
}): ReactElement {
  const memberAuth = getMemberAuth();
  const [nickname, setNickname] = useState<string>("");
  const [nicknamePlaceholder, setNicknamePlaceholder] = useState<string | null>(null);
  useEffect(() => {
    genGuestName().then(username => setNicknamePlaceholder(username));
  }, []);
  return <StyledBoxColumn
    style={{boxSizing: "border-box", width: "100%", maxWidth: 480, marginTop: 48, padding: PD_MD, gap: PD_XLG}}>
    {props.title
      ? <Typography
        variant="h4"
        style={{
          textAlign: "center",
          padding: PD_XLG,
          marginBottom: -PD_XLG
        }}>
        {props.title}
      </Typography>
      : null}
    {props.text
      ? <Typography
        component="div"
        style={{padding: PD_XLG, textAlign: "center"}}>
        <Markdown>
          {props.text}
        </Markdown>
      </Typography>
      : null}
    <StyledBoxColumn>
      {!memberAuth.auth?.currentUser
        ? <>
          <Typography variant="caption">Enter Nickname (or leave empty to use default):</Typography>
          <TextField placeholder={nicknamePlaceholder} size="small" style={{flexGrow: 1}} value={nickname}
                     onChange={event => setNickname(event.target.value?.trim())}/>
        </>
        : null}
      <BuzzButton
        action={new Action(!props.joinRoomId ? "New Buzz" : "Join Buzz", () => {
          const helper = new NewRoomHelper(props.path, memberAuth.member.user.isGuest ? nickname || nicknamePlaceholder : null);
          if (!props.joinRoomId) {
            helper.createAndShowNewRoom();
          } else {
            helper.joinAndShowNewRoom(props.joinRoomId);
          }
        })}/>
      {/*{!props.joinRoomId*/}
      {/*  ? <Button*/}
      {/*    color="secondary"*/}
      {/*    variant="contained"*/}
      {/*    style={{*/}
      {/*      padding: PD_MD,*/}
      {/*      fontSize: "120%",*/}
      {/*      color: "white",*/}
      {/*      fontWeight: "bold",*/}
      {/*    }}*/}
      {/*    onClick={() => {*/}
      {/*      const helper = new NewRoomHelper(props.path, nickname || nicknamePlaceholder);*/}
      {/*      helper.showEnterRoomCodeDialog();*/}
      {/*    }}>*/}
      {/*    {"JOIN BUZZ"}*/}
      {/*  </Button>*/}
      {/*  : null}*/}
      {!props.joinRoomId
        ? <a href="#">
          <Typography
            variant="body2"
            style={{
              textAlign: "right",
              padding: PD_MD,
            }}
            onClick={() => {
              const helper = new NewRoomHelper(props.path, nickname || nicknamePlaceholder);
              helper.showEnterRoomCodeDialog();
            }}>
            {"Have a code? Join the Buzz"}
          </Typography>
        </a>
        : null}
    </StyledBoxColumn>
  </StyledBoxColumn>;
}